import clsx from 'clsx';
import {
  Equalizer,
  FormatListBulleted,
  Note,
  PieChart,
} from '@material-ui/icons';
import { SyntheticEvent } from 'react';
import { IconButton } from '../IconButton';

interface Props {
  title: string;
  views: DashboardCardView[];
  setViewType(view: DashboardCardView): void;
  selected: number;
  onSelect(view: number): void;
}

export const DynamicHeader = ({
  title,
  views: buttons,
  setViewType,
  selected,
  onSelect,
}: Props) => {
  const handleClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onSelect(parseInt(e.currentTarget.id));
    setViewType(e.currentTarget.name as DashboardCardView);
  };

  const isSelected = (number: number) => selected === number;

  const getButtonIcon = (type: string) => {
    const defaultProps: any = { fontSize: 'small' };
    switch (type) {
      case 'graph':
        return <Equalizer {...defaultProps} />;
      case 'pie':
        return <PieChart {...defaultProps} />;
      case 'list':
        return <FormatListBulleted {...defaultProps} />;
      case 'basic':
        return <Note {...defaultProps} />;
      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col items-center justify-between my-2 mx-6">
      <h4 className="text-2xl flex font-bold whitespace-nowrap">{title}</h4>
      <div className="flex flex-row flex-grow items-center justify-center gap-2 p-2">
        {buttons.map((value, index) => (
          <IconButton
            id={index.toString()}
            key={index}
            name={value}
            className={clsx(
              'transition-all ease-in-out duration-200 hover:-translate-y-2 !p-1.5',
              {
                '!bg-background-dark !text-white hover:translate-y-0':
                  isSelected(index),
                '!bg-white !text-background-dark': !isSelected(index),
              }
            )}
            onClick={handleClick}
          >
            {getButtonIcon(value)}
          </IconButton>
        ))}
      </div>
    </div>
  );
};
